export default __webpack_public_path__ + "static/media/flag-sk.babcbf76.svg";